import { createContext, useContext, useState } from 'react'
import type { User } from '../../types'
import TopicModal, { type TopicCreatePayload, type TopicSubmitHandlers } from './TopicModal'
import ActionItemModal from './ActionItemModal'

export interface MeetingCreationContext {
  meetingId: number
  teamId?: number
  teamMembers: User[]
  actionItemMembers: User[]
  currentUserId?: number
}

export const MeetingCreationContext = createContext<MeetingCreationContext | null>(null)

/** Each header owns only its immediate child; recursive topics keep separate drafts. */
export default function MeetingTopicActions({ onSubmit }: {
  onSubmit?: (payload: TopicCreatePayload, handlers: TopicSubmitHandlers) => void
}) {
  const context = useContext(MeetingCreationContext)
  const [child, setChild] = useState<'topic' | 'action' | null>(null)
  if (!context) return null
  const close = () => setChild(null)
  return (
    <>
      <div className="flex gap-1 rounded-button bg-pinnacle-red p-1">
        {(['action', 'topic'] as const).map(kind => (
          <button key={kind} type="button" onClick={() => setChild(kind)}
            className="inline-flex items-center gap-1 px-2 py-2 text-white border border-white/30 rounded-button text-sm font-sans hover:bg-white/10 transition-colors min-h-[44px] whitespace-nowrap">
            <svg aria-hidden="true" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
            </svg>
            {kind === 'action' ? 'Action Item' : 'Add Topic'}
          </button>
        ))}
      </div>
      {child === 'topic' && <TopicModal isOpen onClose={close}
        meetingId={context.meetingId} teamMembers={context.teamMembers}
        currentUserId={context.currentUserId} onSubmit={onSubmit} />}
      {child === 'action' && <ActionItemModal isOpen subtleBackdrop onClose={close}
        meetingId={context.meetingId} teamId={context.teamId} teamMembers={context.actionItemMembers} />}
    </>
  )
}
